module.exports = __webpack_public_path__ + "static/media/JustAct_Rules.567d88b8.pdf";